import React from 'react';
import { Badge } from 'react-bootstrap';

import './FormChangesUI.scss';

export interface IFormChangesUIProps {
  unsavedChanges?: boolean;
  savedChanges?: boolean;
  children?: React.ReactNode;
}

const FormChangesUI = ({ unsavedChanges, savedChanges, children }: IFormChangesUIProps) => (
  <div className="form-changes-content">
    {unsavedChanges && (
      <Badge pill className="changes-badge">
        Unsaved Changes
      </Badge>
    )}
    {savedChanges && (
      <div className="saved-changes">
        <span className="material-icons save-check">done</span>Saved!
      </div>
    )}
    {children}
  </div>
);

FormChangesUI.defaultProps = {
  unsavedChanges: undefined,
  savedChanges: undefined,
  children: undefined,
};

export { FormChangesUI };
